import { createContext, useContext } from 'react';
import { usePersistedValue } from '../hooks/usePersistedValue';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditorUIContext = /*#__PURE__*/createContext({
  showFormattingTray: false,
  setShowFormattingTray: () => {}
});
EditorUIContext.displayName = 'EditorUIContext';
export function useEditorUIStateManager() {
  const [showFormattingTray, setShowFormattingTray] = usePersistedValue('showFormattingTray', false);
  return {
    showFormattingTray,
    setShowFormattingTray
  };
}
export function useEditorUIContext() {
  return useContext(EditorUIContext);
}
export function EditorUIProvider(props) {
  const {
    children
  } = props;
  const {
    showFormattingTray,
    setShowFormattingTray
  } = useEditorUIStateManager();
  return /*#__PURE__*/_jsx(EditorUIContext.Provider, {
    value: {
      showFormattingTray,
      setShowFormattingTray
    },
    children: children
  });
}